/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_List_Status_PartialInputs */



/**
* | output |
* | --- |
* | "Partial list" |
*
* @param {Meta_List_Status_PartialInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const meta_list_status_partial = /** @type {((inputs?: Meta_List_Status_PartialInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_List_Status_PartialInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Teilweise Liste")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Liste partielle")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("部分卡组表")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("部分牌組清單")
	if (locale === "ko") return /** @type {LocalizedString} */ ("일부 리스트")
	return /** @type {LocalizedString} */ ("Partial list")
});